export default __webpack_public_path__ + "static/media/3.069d5235.webp";